export default "__VITE_ASSET__249fc96a__"